module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'closeOrder',
      "lazy": true
    },
    on: {
      "show": _vm.initModal,
      "hidden": _vm.hideCloseModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', [_vm._v("Закрыть заказ № " + _vm._s(_vm.order.id))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Заказ закрывается..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.sum.$error
    }
  }, [_c('label', {
    staticClass: "col-6 form-control-label",
    attrs: {
      "for": "sum-input"
    }
  }, [_vm._v("Общая сумма заказ-наряда")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sum),
      expression: "sum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "rel": "focusThis",
      "id": "sum-input",
      "placeholder": "Сумма по заказ-наряду"
    },
    domProps: {
      "value": (_vm.sum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.sum = $event.target.value
      }, function($event) {
        _vm.$v.sum.$touch()
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.close($event)
      }
    }
  }), _vm._v(" "), (_vm.$v.sum.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Сумма заказ-наряда дожна быть больше 0")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.profit.$error
    }
  }, [_c('label', {
    staticClass: "col-6 form-control-label",
    attrs: {
      "for": "profit-input"
    }
  }, [_vm._v("Комиссия с заказа")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profit),
      expression: "profit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "profit-input",
      "placeholder": "Комиссия по заказ-наряду"
    },
    domProps: {
      "value": (_vm.profit)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.profit = $event.target.value
      }, function($event) {
        _vm.$v.profit.$touch()
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.close($event)
      }
    }
  }), _vm._v(" "), (_vm.$v.profit.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Комиссия должна быть больше 0")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideCloseModal($event)
      }
    }
  }, [_vm._v("Отменить")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-btn', {
    class: {
      'disabled': _vm.$v.sum.$invalid || _vm.$v.profit.$invalid
    },
    attrs: {
      "variant": "success",
      "disabled": _vm.$v.sum.$invalid || _vm.$v.profit.$invalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, [_vm._v("Закрыть заказ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e7b1d19", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-3e7b1d19"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalCloseOrder.vue
// module id = 1030
// module chunks = 1